const ITEMS = [
  "Licensed & Insured",
  "Same-Day Estimates",
  "Port St. Lucie",
  "Treasure Coast Trusted",
  "No Subcontractors",
  "Eco-Friendly Products",
  "Satisfaction Guaranteed",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden bg-[#0F172A] py-5">
      <div className="flex w-max animate-marquee items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display italic text-lg sm:text-xl text-[#FDFBF7] px-6">{item}</span>
            <span className="text-[#D96B43] text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
